/**
 * `?refID=…` — Strapi `LandingpageMapping.documentId` from parent share links.
 */
export type RefIdQuery = {
    isPresent: boolean
    value: string
}

export function parseRefIdQuery(search: string): RefIdQuery {
    const params = new URLSearchParams(
        search.startsWith('?') ? search.slice(1) : search,
    )
    if (!params.has('refID')) {
        return { isPresent: false, value: '' }
    }
    return { isPresent: true, value: params.get('refID') ?? '' }
}

export function hasEffectiveRefId(refIdQuery: RefIdQuery): boolean {
    return refIdQuery.isPresent && refIdQuery.value.trim().length > 0
}
